import { render, staticRenderFns } from "./tokenIDLinkCopyCell.vue?vue&type=template&id=6b4d7e1a"
import script from "./tokenIDLinkCopyCell.vue?vue&type=script&lang=js"
export * from "./tokenIDLinkCopyCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports